import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  searchCaseDocuments,
  searchCaseDocumentsByCaseTags,
} from "../../../api/caseDocuments_api";

export const searchCaseDocumentsAction = createAsyncThunk(
  "caseDocuments/searchCaseDocuments",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await searchCaseDocuments(payload);
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to search documents");
    }
  },
);

export const searchCaseDocumentsByCaseTagsAction = createAsyncThunk(
  "caseDocuments/searchCaseDocumentsByCaseTags",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await searchCaseDocumentsByCaseTags(payload);
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to search documents");
    }
  },
);
